// NPM
import Axios, { AxiosResponse } from "axios";

// Interfaces
import IAppointmentType from "../interfaces/IAppointmentType";

// config
import { LOCAL_HOST, PRACTIQ_API_ENDPOINT, PRACTIQ_API_KEY } from "../utility/config";

const url =
	process.env.NODE_ENV === "production" ? PRACTIQ_API_ENDPOINT : LOCAL_HOST;

export default class AppointmentType {
	
	public static async getAll(
		organisationId: number
	): Promise<AxiosResponse<IAppointmentType[]>> {
		return await Axios.request<IAppointmentType[]>({
			method: "GET",
			url: url + "/appointment/type",
			headers:{
				"X-Api-Key": PRACTIQ_API_KEY
			}
		});
	}

	/**
	 * THIS FUNCTION IS INCLUDED HERE FOR HISTORICAL PURPOSE.
	 * Please use Utility.sortByAttribute instead.
	 *
	 * @param a object of IAppointmentType
	 * @param b object of IAppointmentType
	 * @param sortBy string value of a key of IAppointmentType
	 */
	public static sortByKey(
		a: IAppointmentType,
		b: IAppointmentType,
		sortBy: keyof IAppointmentType
	): number {
		const aVal = a[sortBy];
		const bVal = b[sortBy];

		if (aVal > bVal) return 1;
		if (bVal > aVal) return -1;

		return 0;
	}

	public static sortCategoriesAlphabetically(a: string, b: string): number {
		if (a > b) return 1;
		if (b > a) return -1;

		return 0;
	}

	/**
	 * This function iterates through a list of appointment types and extract the categories
	 * @param apptTypeList a list of appointment types
	 * @returns a string array of all the categories
	 */
	public static extractCategories(
		apptTypeList: IAppointmentType[]
	): string[] {
		const categories: string[] = [];

		apptTypeList.forEach((apptType: IAppointmentType) => {
			const currentCategory: string = apptType.category;
			if (!categories.includes(currentCategory))
				categories.push(currentCategory);
		});

		return categories.sort(AppointmentType.sortCategoriesAlphabetically);
	}

	public static groupByCategory(
		apptType: IAppointmentType,
		category: string
	): boolean {
		return apptType.category === category;
	}

	public static search(
		apptType: IAppointmentType,
		searchTerm: string
	): boolean {
		const regex: RegExp = new RegExp(searchTerm, "i");
		if (searchTerm) {
			return Boolean(apptType.appointmentTypeName.match(regex));
		}
		return true;
	}

	/**
	 * THIS FUNCTION IS NO LONGER IN USED - HERE FOR HISTORICAL PURPOSES
	 * Appointment type used to have the term "new" for new patients
	 * This has been removed from DB Core, so this is no longer relevant
	 *
	 * This function is used with the filter method on array objects
	 * @param apptType The appointment type object
	 */
	public static removeNewPatientAppointmentType(
		apptType: IAppointmentType
	): boolean {
		return !AppointmentType.search(apptType, "new");
	}

	/**
	 * THIS FUNCTION IS NO LONGER IN USED - HERE FOR HISTORICAL PURPOSES
	 * Appointment type used to have the term "new" for new patients
	 * This has been removed from DB Core, so this is no longer relevant
	 *
	 * @param apptTypeName The name of the appointment type
	 * @param apptTypeList The array of appointment type objects
	 */
	public static findAppointmentTypeForNewPatient(
		apptTypeName: string,
		apptTypeList: IAppointmentType[]
	): IAppointmentType | null {
		const filteredList: IAppointmentType[] = apptTypeList.filter(
			(apptType: IAppointmentType) =>
				AppointmentType.search(apptType, apptTypeName)
		);

		const refilteredList: IAppointmentType[] = filteredList.filter(
			(apptType: IAppointmentType) =>
				AppointmentType.search(apptType, "new")
		);

		if (refilteredList.length === 0) return null;

		return refilteredList[0];
	}
}
